<h1 mat-dialog-title>Legal Terms Placeholder</h1>
<div mat-dialog-content>
    <p>Placeholder terms</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-center align-items-end">
    <button mat-button (click)="onNoClick()">Close</button>
</div>
